import type { GetCustomerRevenueReportResponsePayload } from '@weft/api-definition';
import { GetCustomerRevenueReportResponseSchema } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

type GetCustomerRevenueReportPayload = Parameters<ReturnType<typeof getPrivateApi>['getCustomerRevenueReport']>[0];

export function useGetCustomerRevenueReport(options?: UseMutationOptions<GetCustomerRevenueReportResponsePayload, unknown, GetCustomerRevenueReportPayload>) {
  return useMutation(
    ['customer-revenue-report'],
    async (payload) => {
      const privateApi = getPrivateApi();
      const reportId = payload?.reportId;
      const customerRevenueReport = await privateApi.getCustomerRevenueReport({ reportId });

      return GetCustomerRevenueReportResponseSchema.parse(customerRevenueReport);
    },
    options,
  );
}